/** Dezimal-Spalten der Bestellposition — Abschnitt „Decimals“ aus `IwmColumnsBestellposition`. */

import type { OrderPosition } from '@/types/entities';

import { getKalkEkRowColor } from '../rowColors';
import { DecimalCell } from '../shared/DecimalCell';
import { RowColorMarker } from '../shared/RowColorMarker';
import type { CellTemplateMap } from '../types';

export const orderPositionDecimalTemplates: CellTemplateMap<OrderPosition> = {
  Menge: (model) => <DecimalCell value={model.Menge} format="N0" />,
  Einzelpreis: (model) => <DecimalCell value={model.Einzelpreis} />,
  Waehrungskurs: (model) => <DecimalCell value={model.Waehrungskurs} format="N4" />,
  WareWa: (model) => <DecimalCell value={model.WareWa} />,
  WareWaYiyou: (model) => <DecimalCell value={model.WareWaYiyou} />,
  ProvisionYuanfan: (model) => <DecimalCell value={model.ProvisionYuanfan} />,
  EkInklProvision: (model) => <DecimalCell value={model.EkInklProvision} />,
  EkStkInklProvision: (model) => <DecimalCell value={model.EkStkInklProvision} />,
  Seefracht: (model) => <DecimalCell value={model.Seefracht} />,
  Nachlauf: (model) => <DecimalCell value={model.Nachlauf} />,
  Zoll: (model) => <DecimalCell value={model.Zoll} />,
  EinfuhrUst: (model) => <DecimalCell value={model.EinfuhrUst} />,
  Demurrage: (model) => <DecimalCell value={model.Demurrage} />,
  Lagergeld: (model) => <DecimalCell value={model.Lagergeld} />,
  FrachtjeArtikel: (model) => <DecimalCell value={model.FrachtjeArtikel} />,
  FrachtproStueck: (model) => <DecimalCell value={model.FrachtproStueck} />,
  MonatBuchungBh: (model) => <DecimalCell value={model.MonatBuchungBh} format="N0" />,
  JahrBuchungBh: (model) => <DecimalCell value={model.JahrBuchungBh} format="N0" />,

  // mit eigener Farbregel
  KalkEk: (model) => (
    <>
      <RowColorMarker className={getKalkEkRowColor(model)} />
      <DecimalCell value={model.KalkEk} />
    </>
  ),
};

export default orderPositionDecimalTemplates;
